import { SingleDatePicker } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';

export const StyledSingleDatePicker = styled(SingleDatePicker)`
  & .shell-date-picker-dropdown {
    inset: auto 0px auto auto !important;
  }
`;
